import type { AiCapabilityPage } from "../schema.js";
import { LIVE, OWNER_ADMIN } from "./_shared.js";

/**
 * `NAME-IN-GROUP` (@UC0216) — trang **redirect** (US-AIV2-0049): chat KHÔNG hỏi ô, KHÔNG có nút Đồng ý,
 * chỉ một câu giải thích + nút mở đúng màn hình `/groups/:groupId/members` (ADR-0009 bất biến 5).
 * US-AIV2-0110 S10 (`@UC0259`): trước trỏ trang chủ nhóm `/groups/:groupId`; nay tab "Thành viên" — màn chi tiết thành viên cần `memberId` mà engine chưa điền được.
 * Cửa mobile trang này chịu trách nhiệm (QĐ PO 17/09 mục 12 — đổi tên hiển thị; ba cửa vì chủ thể khác nhau (người quản lý đổi cho người khác · tôi đổi tên tôi · tôi đổi khi chưa là thành viên)).
 */
export const NAME_IN_GROUP = {
  id: "NAME-IN-GROUP",
  uc: "@UC0216",
  tier: "redirect",
  status: LIVE,
  roles: OWNER_ADMIN, // US-AIV2-tourguide-0008 (@UC0362 · review #1238 H1): thủ quỹ/thành viên KHÔNG thấy việc này ở màn đích (cờ app `canManageMembers` / sửa đợt = chủ nhóm + quản trị) ⇒ hẹp vai cho đúng app.
  flags: [],
  slots: [],
  llm: {
    description: "Đổi TÊN HIỂN THỊ của bạn RIÊNG trong một nhóm (nhóm khác không đổi theo). KHÔNG phải tên tài khoản toàn hệ thống.",
    examples: [
      "đổi tên hiển thị",
      "doi ten hien thi",
      "tên tôi trong nhóm này",
      "ten toi trong nhom nay",
      "sửa tên bạn ấy trong nhóm",
      "đổi tên của tôi",
      // ——— 0105: thêm cho đủ 40 ———
      "sua ten ban ay trong nhom",
      "doi ten cua toi",
      "tên tôi trong nhóm đang sai, sửa giúp",
      "ten toi trong nhom dang sai sua giup",
      "đổi tên hiển thị trong nhóm lớp",
      "doi ten hien thi trong nhom lop",
      "muốn nhóm gọi tôi là mẹ bé An",
      "muon nhom goi toi la me be An",
      "đặt tên khác cho tôi ở nhóm này",
      "dat ten khac cho toi o nhom nay",
      "sửa tên thành viên trong nhóm",
      "sua ten thanh vien trong nhom",
      "đổi tên bạn Minh trong danh sách nhóm",
      "doi ten ban Minh trong danh sach nhom",
      "tên hiển thị riêng của nhóm",
      "ten hien thi rieng cua nhom",
      "đổi tên hiển thị kiểu gì?",
      "doi ten hien thi kieu gi",
      "trong nhóm này tôi muốn để tên khác",
      "trong nhom nay toi muon de ten khac",
      "sửa tên tôi ở nhóm đội bóng",
      "sua ten toi o nhom doi bong",
      "cho tôi đổi tên hiển thị của mình",
      "cho toi doi ten hien thi cua minh",
      "đổi nickname trong nhóm",
      "doi nickname trong nhom",
      "tên bé ghi sai trong nhóm, sửa lại",
      "ten be ghi sai trong nhom sua lai",
      "đặt lại tên hiển thị",
      "dat lai ten hien thi",
      "gọi tôi bằng tên khác trong nhóm này",
      "goi toi bang ten khac trong nhom nay",
      "sửa tên của Lan ở nhóm",
      "sua ten cua Lan o nhom",
    ],
  },
  screen: "/groups/:groupId/members",
  screenShows: "member_rename",
  endpoints: [
    "PATCH /groups/{groupId}/members/{memberId}/display-name",
    "PATCH /groups/{groupId}/membership",
    "PATCH /users/me/groups/{groupId}/display-name",
  ],
  facts: [],
  templates: {
    redirect: "Mình mở trang thành viên để bạn đổi tên hiển thị nhé. Tên này chỉ đổi trong nhóm đó, không đổi tên tài khoản.",
  },
  journey: { after: ["READ-PEOPLE-MINE"] },
  help: { title: "Đổi tên trong nhóm", tryNow: "đổi tên hiển thị" },
} satisfies AiCapabilityPage;
